export const faqs = [
  {
    question: "17爆料网的内容从哪里来？",
    answer:
      "内容主要来自公开渠道，包括媒体报道、企业或机构的公开声明、平台公开的订单与公告信息，以及读者提供的线索。每篇内容都会标注整理时间与信息来源，方便读者自行核对。",
  },
  {
    question: "网站会发布未经核实的个人信息吗？",
    answer:
      "不会。我们只整理与公共讨论相关的公开信息，不发布个人隐私信息，也不鼓励读者提供此类内容。涉及个人的内容，我们会以「待确认」标注，并避免指向具体个人。",
  },
  {
    question: "文章里的时间线是怎么整理的？",
    answer:
      "时间线只采用可以标注来源的时间点，按发生顺序排列。对于来源不明确的时间点，我们会单独标注，不与已确认的信息混在一起，避免读者误读。",
  },
  {
    question: "如果我发现文章里的信息有误怎么办？",
    answer:
      "可以通过联系我们页面提交更正说明，附上可核对的材料。我们会在一到两个工作日内复核，确认有误的会更新内容并在文末标注更正时间。",
  },
  {
    question: "可以投稿或者提供线索吗？",
    answer:
      "欢迎提供公开性质的线索。请在联系表单中简要描述事件、提供公开可见的来源链接，并留下联系方式。我们不会采纳涉及个人隐私或来源不可核实的内容。",
  },
  {
    question: "网站的内容可以转载吗？",
    answer:
      "欢迎规范转载，请保留原文标题、作者与来源链接，并不得对内容进行删改后用于误导性传播。如需商业使用，请提前取得书面许可。",
  },
];

export const aboutValues = [
  {
    title: "以公开信息为准",
    desc: "只采用可标注来源的材料，把推测与事实分开摆放，不替读者下结论。",
    icon: "ri-scales-3-line",
  },
  {
    title: "尊重当事人",
    desc: "不发布个人隐私，不做指向性推断，讨论公共议题而不针对具体个人。",
    icon: "ri-shield-user-line",
  },
  {
    title: "把时间线讲清楚",
    desc: "用时间顺序替代情绪堆叠，让读者自己看到事件是如何一步步发展的。",
    icon: "ri-history-line",
  },
];